import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/customer-auth`;
const FALLBACK = { label: 'Documento fiscal do país', hint: '5 a 20 caracteres' };
let cache = null;

export const fetchFiscalLabels = async () => {
  if (cache) return cache;
  try {
    const r = await axios.get(`${API}/fiscal-doc-labels`);
    cache = r.data;
  } catch {
    cache = { default: FALLBACK };
  }
  return cache;
};

export const docInfo = (labels, country) =>
  (labels && labels[country]) || (labels && labels.default) || FALLBACK;

/** Limpa o documento (só letras/números maiúsculos), como o servidor faz. */
export const cleanDoc = (value) => (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

/** true quando o documento está exatamente no formato do país escolhido. */
export const docValid = (labels, country, value) => {
  const doc = cleanDoc(value);
  if (!doc) return false;
  const { pattern } = docInfo(labels, country);
  if (!pattern) return doc.length >= 5 && doc.length <= 20;
  try {
    return new RegExp(pattern).test(doc);
  } catch {
    return doc.length >= 5;
  }
};
